import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { WifiOutlined } from '@ant-design/icons';

const OfflineBanner: React.FC = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <Alert
      banner
      type="warning"
      icon={<WifiOutlined />}
      message={<><strong>You're offline.</strong> Changes will save automatically when you reconnect.</>}
    />
  );
};

export default OfflineBanner;
